import * as React from 'react';
import styles from './primary-button.module.scss';

export interface ButtonPrimaryProps {
    label: string;
    className?: string;
    onClick?: () => void;
    disabled?: boolean;
}

export const ButtonPrimary: React.FunctionComponent<ButtonPrimaryProps> = ({ label, onClick, disabled, className }) => {
    const classes = [styles.button];
    if (disabled) {
        classes.push(styles.disabled);
    }
    if (className) {
        classes.push(className);
    }

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        !disabled && onClick && onClick();
    };

    return (
        <button className={classes.join(' ')} onClick={handleClick}>
            {label}
        </button>
    );
};
